import type { DisciplineColor } from '@brighterly/lib-core-types/discipline/types'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useListsStore } from '@shared/model'

export interface DisciplinePayload {
  discipline: Discipline | null
}
export interface DisciplineReturn {
  isDisciplineMath: ComputedRef<boolean>
  isDisciplineEla: ComputedRef<boolean>
  disciplineLabel: ComputedRef<string>
  reversedDisciplineLabel: ComputedRef<string>
  disciplineColor: ComputedRef<DisciplineColor>
  reversedDisciplineColor: ComputedRef<DisciplineColor>
}

const getLabel = (listsStore: ReturnType<typeof useListsStore>, discipline: Discipline): string => {
  return listsStore.lists?.discipline.code[discipline] || discipline
}

export const useDiscipline = (payload: DisciplinePayload): DisciplineReturn => {
  const listsStore = useListsStore()

  const isDisciplineMath = computed(() => payload.discipline === Discipline.Math)
  const isDisciplineEla = computed(() => payload.discipline === Discipline.ELA)

  const disciplineLabel = computed(() => {
    if (isDisciplineMath.value) {
      return getLabel(listsStore, Discipline.Math)
    } else if (isDisciplineEla.value) {
      return getLabel(listsStore, Discipline.ELA)
    } else {
      return ''
    }
  })

  const reversedDisciplineLabel = computed(() => {
    if (isDisciplineMath.value) {
      return getLabel(listsStore, Discipline.ELA)
    } else if (isDisciplineEla.value) {
      return getLabel(listsStore, Discipline.Math)
    } else {
      return ''
    }
  })

  const disciplineColor = computed(() => {
    if (isDisciplineMath.value) {
      return 'indigo'
    } else if (isDisciplineEla.value) {
      return 'blue'
    } else {
      return ''
    }
  })

  const reversedDisciplineColor = computed(() => {
    if (isDisciplineMath.value) {
      return 'blue'
    } else if (isDisciplineEla.value) {
      return 'indigo'
    } else {
      return ''
    }
  })

  return {
    isDisciplineMath,
    isDisciplineEla,
    disciplineLabel,
    reversedDisciplineLabel,
    disciplineColor,
    reversedDisciplineColor,
  }
}

export interface RawDisciplineReturn {
  isDisciplineMath: boolean
  isDisciplineEla: boolean
}
export const useRawDiscipline = (payload: DisciplinePayload): RawDisciplineReturn => {
  const isDisciplineMath = payload.discipline === Discipline.Math
  const isDisciplineEla = payload.discipline === Discipline.ELA

  return {
    isDisciplineMath,
    isDisciplineEla,
  }
}
